module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=MK - North Macedonia.6e7aa780.svg";